import { render } from "./Particulars.vue?vue&type=template&id=2e0ed022&scoped=true"
import script from "./Particulars.vue?vue&type=script&lang=js"
export * from "./Particulars.vue?vue&type=script&lang=js"

import "./Particulars.vue?vue&type=style&index=0&id=2e0ed022&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0ed022"]])

export default __exports__